import React from 'react'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import GoogleIcon from '../../../components/icon/GoogleIcon'
import { UI_COLOR_PRIMARY_ALT } from '../../../constants/uiColors'
import {
  rbacSectionCardSx,
  rbacSectionDividerSx,
  rbacSectionHeaderSx,
  rbacSectionIconBoxSx,
  rbacSectionTitleSx
} from '../../components/constants/rbacDetailCardConstants'

const SECTION_ICON_SIZE = 16

export default function RbacRoleSectionCard({
  title,
  iconName = 'info',
  icon: Icon,
  iconWeight = 'regular',
  children,
  sx = {},
  headerSx = {},
  bodySx = {},
  titleSx = {}
}) {
  const iconNode = Icon ? (
    <Icon size={SECTION_ICON_SIZE} weight={iconWeight} color={UI_COLOR_PRIMARY_ALT} />
  ) : (
    <GoogleIcon name={iconName} size={SECTION_ICON_SIZE} color={UI_COLOR_PRIMARY_ALT} />
  )

  return (
    <Paper variant="outlined" sx={{ ...rbacSectionCardSx, ...sx }}>
      <Box sx={{ ...rbacSectionHeaderSx, ...headerSx }}>
        <Box sx={rbacSectionIconBoxSx}>{iconNode}</Box>
        <Typography sx={{ ...rbacSectionTitleSx, ...titleSx }}>{title}</Typography>
      </Box>

      <Divider sx={rbacSectionDividerSx} />

      <Box sx={bodySx}>{children}</Box>
    </Paper>
  )
}
